export enum IHubContentProvider {
    INSIGHT_FAMILIES = "INSIGHT_FAMILIES",
    INSIGHTS_FROM_AI = "INSIGHTS_FROM_AI",
    PACKAGES = "PACKAGES",
    TEMPLATES = "TEMPLATES",
    MARKETING_NARRATIVES = "MARKETING_NARRATIVES",
    GENERATED_INSIGHTS = "GENERATED_INSIGHTS",
    PACKAGE_INSIGHTS = "PACKAGE_INSIGHTS",
    UNIFIED = "UNIFIED",
}

// To be finalized
export enum InsightFamilyName {
    AUDIENCE_FUNNEL_SIZING = "AudienceFunnelSizing",
    BRAND_LOYALTY = "BrandLoyalty",
    NEW_TO_BRAND = "NewToBrand",
    PATH_TO_PURCHASE = "PathToPurchase",
    PEER_BENCHMARKING = "PeerBenchmarking",
    PEER_BENCHMARKING_UAT = "PeerBenchmarkingUat",
    BRAND_LOYALTY_UAT = "BrandLoyaltyUat",
    REPEAT_PURCHASER = "RepeatPurchaser",
    SHARE_OF_VOICE = "ShareOfVoice",
    BRANDED_SEARCH_TRENDS = "BrandedSearchTrends",
    INSIGHT_GENIE = "A&IPilotInsights",
}

// From https://code.amazon.com/packages/CaireModel/blobs/mainline/--/src/com/amazon/caire/model/recommendation/RecommendationSource.java
export enum PackageSource {
    CREATIVE_INTELLIGENCE = "CREATIVE_INTELLIGENCE",
    CAIRE = "CAIRE",
    SEASONAL_EVENT = "SEASONAL_EVENT",
    GENERIC_SEASONAL_EVENT = "GENERIC_SEASONAL_EVENT",
}

// From https://code.amazon.com/packages/D16GCDBPublisherPortalLambda/blobs/mainline/--/src/main/java/com/amazon/d16gcdbpublisherportal/enums/Theme.java
export enum InsightDeckTemplateTheme {
    AD_PRODUCTS = "Ad Products",
    ADVERTISER_GOALS = "Advertiser Goals",
    DOWNSTREAM_IMPACT = "Downstream Impact",
    INDUSTRY_INSIGHTS = "Industry Insights",
    SEASONAL_EVENTS = "Seasonal Events",
}

// From ACC, update to ids that are needed.
export enum MarketingContentType {
    ALL = "",
    PITCH_DECK = "18d0e2d6-bbf9-4346-b6ea-6a21a977b52f",
    CASE_STUDY = "efb3438d-cb13-4695-9774-16cbed61f0b4",
    ONE_SHEETER = "31f2eb16-69bc-49f4-9118-963c4ab0f1da",
    PRIMARY_TEMPLATE = "18fc2134-0df1-4566-ad35-68b318e2ef22",
    LWP = "7dd4cf1d-825d-4090-91b5-196c4bbc4c34",
    PRODUCT_CARD = "e81f2681-41a7-4393-a2ed-fa7d56bc7b03",
    GUIDE = "952d9654-2a8d-4a5a-a1ac-c66d3ec84f20",
    TRAINING = "b0e50e0e-afb8-4fef-a4d3-39b639503bfe",
    BRIEF = "f9e4326e-e57b-4711-99af-5d5d8d74741f",
}

export type IHubContentScope =
    | InsightFamilyName
    | PackageSource
    | InsightDeckTemplateTheme
    | MarketingContentType;
